import defaultLogo from '../../../../assets/images/Wyenfos_bills_logo.png';
import { API_CONFIG } from '../../../../utils/apiConfig';
import wyenfosInfotechLogo from '../../../../assets/company-logos/wyenfos_infotech.png';
import wyenfosGoldLogo from '../../../../assets/company-logos/wyenfos_gold.png';
import wyenfosAdsLogo from '../../../../assets/company-logos/wyenfos_ads.png';
import wyenfosCashLogo from '../../../../assets/company-logos/wyenfos_cash.png';
import ayurLifeLogo from '../../../../assets/company-logos/Ayur4life_logo.png';
import wyenfosLogo from '../../../../assets/company-logos/wyenfos.png';
import wyenfosPureDropsLogo from '../../../../assets/company-logos/wyenfos pure drops.png';

export const getLogoUrl = (logoPath, companyName) => {
  // Local logo mapping - works in both development and production
  const localLogoMap = {
    'WYENFOS INFOTECH': wyenfosInfotechLogo,
    'WYENFOS GOLD AND DIAMONDS': wyenfosGoldLogo,
    'WYENFOS ADS': wyenfosAdsLogo,
    'WYENFOS CASH VAPASE': wyenfosCashLogo,
    'AYUR4LIFE HERBALS INDIA': ayurLifeLogo,
    'WYENFOS': wyenfosLogo,
    'WYENFOS PURE DROPS': wyenfosPureDropsLogo,
  };

  // First, try to use local logo based on company name (prioritize this over logoPath)
  if (companyName && localLogoMap[companyName]) {
    return localLogoMap[companyName];
  }

  // If we have a logoPath from Firestore and it's a full URL, use it
  if (logoPath && logoPath.startsWith('http')) {
    return logoPath;
  }

  // For development, try API server for uploaded logos
  if (process.env.NODE_ENV === 'development' && logoPath) {
    if (logoPath.startsWith('/uploads') || logoPath.startsWith('/Uploads')) {
      return `${API_CONFIG.BASE_URL}${logoPath}`;
    }
  }

  // If no valid logoPath and no company name match, fallback to default logo
  return defaultLogo;
};

export const getCompanyDetails = (companyName) => {
  const companyDetails = {
    'WYENFOS INFOTECH': {
      name: 'WYENFOS INFOTECH',
      address: 'Thekkekara Arcade, Chelakottukara, Thrissur, Kerala, 680001',
      GSTIN: '32AAECW1234B1Z0',
      state: 'Kerala',
      stateCode: '32',
      mobile: '+91 9847012345',
      email: 'info@wyenfos.com',
      website: 'www.wyenfos.com',
      logo: '/uploads/wyenfos_infotech.png',
      qrCode: '/uploads/bank-qr-codes/COMBINED_WYENFOS_1755333147704.png',
      prefix: 'WIT'
    },
    'WYENFOS GOLD AND DIAMONDS': {
      name: 'WYENFOS GOLD AND DIAMONDS',
      address: 'Thekkekara Arcade, Chelakottukara, Thrissur, Kerala, 680001',
      GSTIN: '32AAECW1234B1Z1',
      state: 'Kerala',
      stateCode: '32',
      mobile: '+91 9847012346',
      email: 'gold@wyenfos.com',
      website: 'www.wyenfosgold.com',
      logo: '/uploads/wyenfos_gold.png',
      qrCode: '/uploads/bank-qr-codes/COMBINED_WYENFOS_GOLD_AND_DIAMONDS_1755332863742.png',
      prefix: 'WGD'
    },
    'WYENFOS ADS': {
      name: 'WYENFOS ADS',
      address: 'Thekkekara Arcade, Chelakottukara, Thrissur, Kerala, 680001',
      GSTIN: '32AAECW1234B1Z2',
      state: 'Kerala',
      stateCode: '32',
      mobile: '+91 9847012347',
      email: 'ads@wyenfos.com',
      website: 'www.wyenfosads.com',
      logo: '/uploads/wyenfos_ads.png',
      qrCode: '/uploads/bank-qr-codes/COMBINED_WYENFOS_1755333147704.png',
      prefix: 'WAD'
    },
    'WYENFOS CASH VAPASE': {
      name: 'WYENFOS CASH VAPASE',
      address: 'Thekkekara Arcade, Chelakottukara, Thrissur, Kerala, 680001',
      GSTIN: '32AAECW1234B1Z3',
      state: 'Kerala',
      stateCode: '32',
      mobile: '+91 9847012348',
      email: 'vapase@wyenfos.com',
      website: 'www.wyenfosvapase.com',
      logo: '/uploads/wyenfos_cash.png',
      qrCode: '/uploads/bank-qr-codes/COMBINED_WYENFOS_CASH_VAPASE_1755490549175.png',
      prefix: 'WCV'
    },
    'AYUR4LIFE HERBALS INDIA': {
      name: 'AYUR4LIFE HERBALS INDIA',
      address: 'Ayur4Life Building, Thrissur, Kerala, 680001',
      GSTIN: '32AAECW1234B1Z4',
      state: 'Kerala',
      stateCode: '32',
      mobile: '+91 9847012349',
      email: 'info@ayur4life.com',
      website: 'www.ayur4life.com',
      logo: '/uploads/Ayur4life_logo.png',
      qrCode: '/uploads/bank-qr-codes/COMBINED_WYENFOS_1755333147704.png',
      prefix: 'ALH'
    },
    'WYENFOS': {
      name: 'WYENFOS',
      address: 'Thekkekara Arcade, Chelakottukara, Thrissur, Kerala, 680001',
      GSTIN: '32AAECW1234B1Z5',
      state: 'Kerala',
      stateCode: '32',
      mobile: '+91 9847012350',
      email: 'contact@wyenfos.com',
      website: 'www.wyenfos.com',
      logo: '/uploads/wyenfos.png',
      qrCode: '/uploads/bank-qr-codes/WYENFOS_QR_1755336487474.png',
      prefix: 'WNF'
    },
    'WYENFOS PURE DROPS': {
      name: 'WYENFOS PURE DROPS',
      address: 'Thekkekara Arcade, Chelakottukara, Thrissur, Kerala, 680001',
      GSTIN: '32AAECW1234B1Z6',
      state: 'Kerala',
      stateCode: '32',
      mobile: '+91 9847012351',
      email: 'drops@wyenfos.com',
      website: 'www.wyenfospuredrops.com',
      logo: '/uploads/wyenfos pure drops.png',
      qrCode: '/uploads/bank-qr-codes/COMBINED_WYENFOS_1755333147704.png',
      prefix: 'WPD'
    },
    'WYENFOS CHARITABLE TRUST': {
      name: 'WYENFOS CHARITABLE TRUST',
      address: 'Thekkekara Arcade, Chelakottukara, Thrissur, Kerala, 680001',
      GSTIN: '32AAECW1234B1Z7',
      state: 'Kerala',
      stateCode: '32',
      mobile: '+91 9847012352',
      email: 'charitable@wyenfos.com',
      website: 'www.wyenfoscharitable.com',
      logo: '/uploads/wyenfos.png',
      qrCode: '/uploads/bank-qr-codes/WYENFOS_QR_1755336487474.png',
      prefix: 'WCT'
    },
  };

  // Handle company name mapping for backward compatibility
  if (companyName === 'AYUR 4 LIFE HERBALS India') {
    companyName = 'AYUR4LIFE HERBALS INDIA';
  }
  if (companyName === 'WYENFOS GOLD & DIAMONDS') {
    companyName = 'WYENFOS GOLD AND DIAMONDS';
  }

  return companyDetails[companyName] || {
    name: companyName || 'WYENFOS',
    address: 'Thekkekara Arcade, Chelakottukara, Thrissur, Kerala, 680001',
    GSTIN: '32AAECW1234B1Z0',
    state: 'Kerala',
    stateCode: '32',
    mobile: '',
    email: '',
    website: '',
    logo: '/uploads/wyenfos.png',
    qrCode: '/uploads/bank-qr-codes/WYENFOS_QR_1755336487474.png',
    prefix: 'WNF'
  };
};
